import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

const RatesDisplay = ({ rates = {}, isLoading, formatCurrency }) => {
    const [selectedType, setSelectedType] = useState(Object.keys(rates)[0] || '');
    const carTypes = Object.keys(rates);

    return (
        <div className="space-y-4">
            {isLoading ? (
                <div className="flex items-center justify-center p-8">
                    <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
                </div>
            ) : (
                <>
                    {/* Tabs */}
                    <div className="flex space-x-1 border-b border-gray-200">
                        {carTypes.map((type) => (
                            <button
                                key={type}
                                onClick={() => setSelectedType(type)}
                                className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors outline-0 focus:outline-none ${selectedType === type
                                        ? 'text-white bg-purple-600'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                                    }`}
                            >
                                {type.replace(/_/g, ' ')}
                            </button>
                        ))}
                    </div>

                    {/* Rate Grid */}
                    {selectedType && rates[selectedType] && (
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                            {Object.entries(rates[selectedType]).map(([range, data]) => {
                                if (range !== 'app_fee' && range !== 'vat_percentage') {
                                    const label = range
                                        .replace(/km/g, '')
                                        .split('_')
                                        .map(part => {
                                            if (part === '90') return '90+ Km';
                                            // Add Km to all numeric ranges
                                            return !isNaN(part) ? `${part} Km` : part;
                                        })
                                        .join(' - ');

                                    return (
                                        <div
                                            key={range}
                                            className="bg-gray-50 px-4 rounded-lg flex flex-col"
                                        >
                                            <span className="text-sm text-gray-600">{label}</span>
                                            <span className="text-lg font-semibold text-gray-900 mt-1">
                                                {formatCurrency(data.rate)}
                                            </span>
                                        </div>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    )}

                    {/* App Fee Display */}
                    {selectedType && rates[selectedType] && (
                        <div className="mt-4 space-y-2">
                            {/* App Fee Display */}
                            {typeof rates[selectedType].app_fee !== 'undefined' && (
                                <div className="px-4">
                                    <span className="text-md font-medium text-purple-600">
                                        App Fee: {formatCurrency(rates[selectedType].app_fee)}
                                    </span>
                                </div>
                            )}
                            
                            {/* Cancelled Rate Display */}
                            {typeof rates[selectedType].cancelled !== 'undefined' && (
                                <div className="px-4">
                                    <span className="text-md font-medium text-purple-600">
                                        Cancelled Rate: {formatCurrency(rates[selectedType].cancelled)}
                                    </span>
                                </div>
                            )}
                            
                            {/* VAT Percentage Display */}
                            {typeof rates[selectedType].vat_percentage !== 'undefined' && (
                                <div className="px-4">
                                    <span className="text-md font-medium text-purple-600">
                                        VAT: {rates[selectedType].vat_percentage}%
                                    </span>
                                </div>
                            )}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default RatesDisplay;
